import { Tv, Smartphone, Monitor, Cast } from "lucide-react";

const systems = [
  { os: "Android (celular, tablet, TV Box)", apps: "New Braz, New Hybrid, Dream TV, VEJO V3" },
  { os: "Samsung Smart TV (Tizen)", apps: "IBO Player, Dream TV, XCLOUD TV, Smarters Player" },
  { os: "LG Smart TV (webOS)", apps: "IBO Player, Smarters Player, Dream TV" },
  { os: "Roku TV", apps: "Dream TV, XCLOUD TV" },
  { os: "iOS (iPhone/iPad)", apps: "XCLOUD TV, Smarters Player, Stream Player ISP" },
  { os: "Windows PC / Mac / Linux", apps: "Smarters Player, Purple IPTV, VLC" },
];

const devices = [
  {
    icon: Tv,
    title: "Smart TV",
    desc: "Samsung (Tizen, modelos 2016+), LG (webOS 3.0+), Android TV (Sony, Philips, TCL) e Roku TV.",
  },
  {
    icon: Cast,
    title: "TV Box e Fire Stick",
    desc: "TV Box Android, Amazon Fire TV Stick, Mi Box e Chromecast com Google TV.",
  },
  {
    icon: Smartphone,
    title: "Celular e Tablet",
    desc: "Android 5.0+ (Samsung, Xiaomi, Motorola) e iOS 12+ (iPhone, iPad).",
  },
  {
    icon: Monitor,
    title: "Computador",
    desc: "Windows 7/8/10/11, macOS 10.12+ e Linux (todas as distribuições).",
  },
];

export const Devices = () => (
  <section id="dispositivos" data-testid="devices-section" className="py-24 px-4 sm:px-6 bg-[#0F0F13]/50 border-y border-white/10">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-14">
        <p className="text-[#FF5A00] text-sm font-bold uppercase tracking-[0.25em] mb-3">Compatibilidade</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter mb-4" style={{ fontFamily: "Outfit, sans-serif" }}>
          Assista em <span className="text-[#FF5A00]">qualquer dispositivo</span>
        </h2>
        <p className="text-white/55 max-w-xl mx-auto text-base">
          Use em 1 dispositivo por vez e alterne facilmente entre sua Smart TV, celular, tablet ou computador.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
        {devices.map((d, i) => (
          <div
            key={i}
            data-testid={`device-card-${i}`}
            className="bg-[#0F0F13] border border-white/10 rounded-2xl p-7 hover:-translate-y-1 hover:border-[#FF5A00]/40 transition-all duration-300"
          >
            <div className="w-12 h-12 rounded-xl bg-[#FF5A00]/10 border border-[#FF5A00]/20 flex items-center justify-center mb-4">
              <d.icon className="w-6 h-6 text-[#FF5A00]" />
            </div>
            <h3 className="text-lg font-bold mb-2" style={{ fontFamily: "Outfit, sans-serif" }}>{d.title}</h3>
            <p className="text-sm text-white/55 leading-relaxed">{d.desc}</p>
          </div>
        ))}
      </div>

      <div className="bg-[#0F0F13] border border-white/10 rounded-2xl overflow-hidden">
        <div className="px-6 sm:px-8 py-5 border-b border-white/10">
          <h3 className="text-lg font-bold" style={{ fontFamily: "Outfit, sans-serif" }}>
            Apps por sistema operacional
          </h3>
        </div>
        <div className="divide-y divide-white/5">
          {systems.map((s, i) => (
            <div
              key={i}
              data-testid={`os-row-${i}`}
              className="px-6 sm:px-8 py-4 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-6"
            >
              <span className="sm:w-72 shrink-0 text-sm font-bold text-white">{s.os}</span>
              <span className="text-sm text-white/55">{s.apps}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
